import { useRegisterSW } from 'virtual:pwa-register/vue'

export function usePWA() {
    const {
        needRefresh,
        offlineReady,
        updateServiceWorker,
    } = useRegisterSW()

    return {
        needRefresh,
        offlineReady,
        updateServiceWorker,
    }
}
